module.exports = __webpack_public_path__ + "img/grp-part-6-option-2.5a3795ff.png";